import styled from 'styled-components';
import backgroundImage from '@/assets/hero.png';

export const Background = styled.div(({ theme }) =>
  theme.withMedia({
    backgroundImage:
      `linear-gradient(
        rgba(24,29,64,1) 3%,
        rgba(44,42,108,0.90) 90%,
        rgba(44,42,108,0.93) 99%
       ),url("${backgroundImage}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'right',
    height: ['193px', '324px', '324px'],
    width: '100%',
  })
);

export const Section = styled.section(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%',
    maxWidth: ['540px', '720px', '1200px'],
    padding: '0 12px',
    margin: '0 auto',
    position: 'relative',
  })
);

export const HeroTitle = styled.div(({ theme }) =>
  theme.withMedia({
    color: '#DADCE5',
    fontSize: ['24px', '40px', '40px'],
    fontWeight: '600',
    lineHeight: ['32px', '56px', '56px'],
  })
);

export const HeroSubtitle = styled.div(({ theme }) =>
  theme.withMedia({
    color: '#A8ADBF',
    fontSize: '16px',
    fontWeight: '200',
    lineHeight: '24px',
    marginTop: '8px',
    width: ['81%', '100%', '100%']
  })
);

export const Button = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
    width: '176px',
    height: '36px',
    padding: '8px 16px',
    borderRadius: '4px',
    backgroundColor: '#B2332D',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#F2F2F2',
    marginTop: '32px',

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#9f211c'
    }
  })
);
